import { styled, TableRow } from '@mui/material';
export const DisabledTableRow = styled(TableRow, {
    shouldForwardProp: (prop) => prop !== 'disabled',
})(({ theme, disabled }) => ({
    '&.MuiTableRow-root': disabled && {
        backgroundColor: 'inherit',
        '& .MuiTableCell-root': {
            fontWeight: 400,
            backgroundColor: 'inherit',
            color: theme.palette.text.disabled,
        },
        '&:hover': {
            backgroundColor: 'inherit',
            cursor: 'default',
        },
    },
}));
